/* eslint-disable import/no-unresolved,import/prefer-default-export */
import React from 'react';
import { Body, LeftPanel } from 'assets/components';
import {
  BalanceCardPlaceholder,
  SettingButtonPlaceholder,
  TransactionItemPlaceholder,
} from '../Placeholders';

export const SkeletonPageLoader = () => (
  <div className="container p-0">
    <div className="d-flex flex-column flex-md-row mt-5 px-4 px-md-0">
      <LeftPanel>
        <BalanceCardPlaceholder />
        <SettingButtonPlaceholder />
      </LeftPanel>
      <Body>
        <div className="d-flex flex-column gap-3">
          <TransactionItemPlaceholder />
          <TransactionItemPlaceholder />
          <TransactionItemPlaceholder />
          <TransactionItemPlaceholder />
        </div>
      </Body>
    </div>
  </div>
);
